import View from '../core/View';
import URLUtils from '../util/URLUtils';

export default class LibraryInfoView extends View {

    createView(model) {

        let visualTemplate = model['visualTemplate'];

        let images = visualTemplate.horizontalLibraryInfoImages;
        images = (images.length > 0) ? images : visualTemplate.verticalLibraryInfoImages;

        this.imgWidth = 0;
        this.imgHeight = 0;

        this.infoBackground = $('<div>', {
            css: {
                'position': 'absolute',
                'left': '0px',
                'top': '0px',
                'width': '100%',
                'height': '100%',
                'z-index': '99',
                'background-color': 'rgba(0,0,0,0.7)'
            }
        }).click(() => { this.infoBackground.remove(); }).appendTo('body');

        this.infoBox = $('<div>', {
            css: {
                'position': 'relative',
                'left': '50%',
                'top': '50%',
                'transform': 'translate(-50%, -50%)',
                'padding': '20px',
                'border-radius': '10px',
                'background-color': '#DEDEDE'
            }
        }).click((e) => { e.stopPropagation(); }).appendTo(this.infoBackground);

        this.infoContent = $('<div>', {
            css: {
            }
        }).appendTo(this.infoBox);

        this.infoContent.hide();

        let deferred = new $.Deferred();
        let promise = deferred;

        for (let path of images) {
            promise = promise.then(() => {
                let img = $('<img>', {
                    src: `${URLUtils.getURL(this.app.baseUrl + path)}`
                }).appendTo(this.infoContent);

                let d = new $.Deferred();

                img.load(() => {
                    this.imgWidth = img[0].width;
                    this.imgHeight = img[0].height;
                    d.resolve();
                });

                return d;
            });
        }

        promise.then(() => {
            this.onResize();
            if (images.length > 1) {
                this.infoContent.slidesjs({
                    width: this.imgWidth,
                    height: this.imgHeight,
                    navigation: {
                        active: false
                    }
                });
            } else {
                this.infoContent.children('img').css({
                    'width': '100%',
                    'height': '100%'
                });
            }
            this.infoContent.show();
        });

        deferred.resolve();

        $(window).resize(this.onResize.bind(this));

    }

    onResize() {
        let maxWidth = this.infoBackground.width() * 0.8;
        let maxHeight = this.infoBackground.height() * 0.8;

        let widthRatio = maxWidth / this.imgWidth;
        let heightRatio = maxHeight / this.imgHeight;
        let scaleRatio = (widthRatio < heightRatio) ? widthRatio : heightRatio;

        let width = this.imgWidth * scaleRatio;
        let height = this.imgHeight * scaleRatio;

        this.infoBox.css('width', width+40);

        this.infoContent.css('width', width);
        this.infoContent.css('height', height);
    }

}
